<!--流程自助详情-->
<!--wj-->
<template>
    <div class="psDetail detail-wapper">
        <detail-title></detail-title>
        <div class="detail-title"><strong>{{list.trstName}}</strong></div>
        <div class="detail-content" v-html="list.trstContent">{{list.trstContent}}</div>
        <div class="detail-bottom"></div>
        <share-wechat></share-wechat>
    </div>
</template>
<script>
import Axios from 'axios';
import { eventBus } from '@/assets/js/eventBus';
import ShareWechat from "@/components/ShareWechat";
import { setTimeout } from 'timers';
import DetailTitle from '@/components/DetailTitle';
export default {
    name: 'psDetail',
    data() {
        return {
           list:[],
        };
    },
    mounted() {
        const that = this;
        var id;
        var locations = location.href;
        if (locations.indexOf("?") != -1) {    //判断是否有参数
          if(locations.indexOf("from") != -1){
                var str = locations.substr(0); //从第一个字符开始 因为第0个是?号 获取所有除问号的所有符串
                var strs = str.split("?");
                id = strs[2];
          }else{
            var str = locations.substr(0); //从第一个字符开始 因为第0个是?号 获取所有除问号的所有符串
            var strs = str.split("?");
            id = strs[1];   //用等号进行分隔 （因为知道只有一个参数 所以直接用等号进分隔 如果有多个参数 要用&号分隔 再用等号进行分隔）
          }
        }
        const loading = that.$loading({//加载延时提示
            lock: true,
            text: '正在获取数据',
            spinner: 'el-icon-loading',
            color:'#f3f3f3',
            background: 'rgba(250, 250, 250, 0.01)',
        });
        Axios.get(that.$store.state.APIURLS+"Trst/findById?"+id).then((res) => {
            if(res.data.code == 200){
                loading.close();  
                that.list = res.data.data;
                var shareList = {
                    title: res.data.data.trstName,
                    content: res.data.data.trstContent,
                };
                eventBus.$emit("shareList", shareList);
            }
        });
    },
    components:{
        DetailTitle,
        ShareWechat
    },
};
</script>
